import { render, staticRenderFns } from "./NotFoundMessage.vue?vue&type=template&id=15c8c388&"
import script from "./NotFoundMessage.vue?vue&type=script&lang=js&"
export * from "./NotFoundMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports